module.exports = __webpack_public_path__ + "img/logo15.35220798.png";